import { PaymentCreditCard } from '@/types/Payment'
import { Box, CircularProgress, IconButton, Stack, Tooltip, Typography } from '@mui/material'
import { DeleteOutlineOutlined } from '@mui/icons-material'

export const CreditCardItem: React.FC<{
  card: PaymentCreditCard
  onDelete: (cardId: number) => void
  isDeleting: boolean
}> = ({ card, onDelete, isDeleting }) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      border="1px solid #e0e0e0"
      bgcolor="white"
      padding={2}
      borderRadius={2}
    >
      <Stack direction="row" alignItems="center" spacing={2}>
        <Box
          component="img"
          src={`/assets/png/card-brands/${card.brand.toLowerCase()}.png`}
          alt={card.brand}
          height={45}
          width={72}
          sx={{ objectFit: 'contain' }}
        />
        <Stack direction="column" spacing={0.5}>
          <Typography variant="body2" lineHeight={1.2} color="textSecondary">
            {card.card_mask.replace(/(.{4})/g, '$1 ')}
          </Typography>
          <Typography variant="caption" color="textSecondary">
            Vencimento: {card.expiration_month}/{card.expiration_year}
          </Typography>
        </Stack>
      </Stack>
      <Stack direction="row" spacing={1}>
        <Tooltip title="Remover">
          <span>
            <IconButton color="error" onClick={() => onDelete(card.id)} disabled={isDeleting}>
              {isDeleting ? <CircularProgress size={24} /> : <DeleteOutlineOutlined />}
            </IconButton>
          </span>
        </Tooltip>
      </Stack>
    </Stack>
  )
}
